module.exports = __webpack_public_path__ + "static/media/Tickblue.5bddf667.svg";